export const catchError = (ex, onError) => dispatch => {
    const GENERIC_GRID_VIEW_SET_SEARCH_PENDING_STATUS = 'GENERIC_GRID_VIEW_SET_SEARCH_PENDING_STATUS';
    dispatch({
        type: GENERIC_GRID_VIEW_SET_SEARCH_PENDING_STATUS,
        payload: {
            isSearching: false
        },
    });
    
    const loaderEl = document.getElementById('mainGenericLoader');
    if (loaderEl) {
        loaderEl.classList.remove('active');
    }

    if (ex.response) {
        ex.response.json().then(error => dispatch(onError(error)));
    } else {
        dispatch(onError(ex));
    }
}
